import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import { forwardRef, useState, useMemo, useCallback, useEffect } from 'react';
import merge from 'deepmerge';
import 'prop-types';
import { useReactlyticsHandlers } from '@americanexpress/reactlytics';
import btnFloat from '../../styles/btnFloat.js';
import { dlsWhite } from '../../styles/colorsDls/dlsWhite.js';
import { icon } from '../../styles/iconography/icon.js';
import { iconSm } from '../../styles/iconography/iconSm.js';
import { dlsIconUp } from '../../styles/iconography/dlsIconUp.js';
import btnCircle from '../../styles/btnCircle.js';
import btnFloatingScroll from '../../styles/btnFloatingScroll.js';
import defaultLabels from './Button.en-US.js';
import useLocaleToDeriveDefault from '../LocaleProvider/hooks/useLocaleToDeriveDefault.js';
import { jsx } from '@emotion/core';

const ButtonFloatingScroll = /*#__PURE__*/forwardRef((props, ref) => {
  const [isHidden, setIsHidden] = useState(true);
  const {
    label,
    anchor,
    theme,
    ...otherProps
  } = useReactlyticsHandlers(props, ['onClick']);
  const derivedLabel = useLocaleToDeriveDefault(label, defaultLabels.scrollToTop);
  const cssObject = useMemo(() => merge.all([btnCircle.btnCircle, btnFloat.btnFloat, dlsWhite, icon, iconSm, dlsIconUp, {
    zIndex: 1
  }, isHidden ? {
    visibility: 'hidden'
  } : {
    visibility: 'visible'
  }]), [isHidden]);
  const cssStyle = useMemo(() => merge.all([btnFloatingScroll.btnFloatingScroll, {
    ' > a': btnFloatingScroll.btnFloatingScroll___a
  }, {
    // get the styles for each screen size
    '@media (min-width: 375px)': btnFloatingScroll['@media (min-width: 375px)'].btnFloatingScroll,
    '@media (min-width: 768px)': btnFloatingScroll['@media (min-width: 768px)'].btnFloatingScroll,
    '@media (min-width: 1024px)': btnFloatingScroll['@media (min-width: 1024px)'].btnFloatingScroll,
    '@media (min-width: 1280px)': btnFloatingScroll['@media (min-width: 1280px)'].btnFloatingScroll
  }, theme]), [theme]);

  // The viewport height is calculated when clientHeight is used on the
  // root element (<html>) of the document
  const totalHeight = document.documentElement.clientHeight;
  const handleScroll = useCallback(() => {
    // Find the current scroll height of the user to determine
    // if 20% of the page content has been scrolled through
    const currentHeight = document.documentElement.scrollTop;
    if (currentHeight >= totalHeight * 0.2) {
      setIsHidden(false);
    } else {
      setIsHidden(true);
    }
  }, [totalHeight]);
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
  return jsx("div", {
    css: cssStyle,
    ref: ref,
    onScroll: handleScroll
  }, jsx("a", _extends({
    href: `#${anchor}`,
    "aria-label": derivedLabel,
    title: derivedLabel,
    css: cssObject
  }, otherProps)));
});
ButtonFloatingScroll.displayName = 'ButtonFloatingScroll';
ButtonFloatingScroll.defaultProps = {
  anchor: 'top',
  label: undefined,
  theme: {}
};
var ButtonFloatingScroll$1 = ButtonFloatingScroll;

export { ButtonFloatingScroll$1 as default };
